import { useTranslation } from 'react-i18next';
import { formatOrderCriteria } from 'utils';
import { useSearchParams } from 'hooks';
import { getSettingRequests } from 'api/node/settingRequests';
import { useAsync } from 'react-async';
import { KoobDataTable, KoobTableAction, koobTableUrlSort } from '@koob/ui';
import { useState } from 'react';
import { isEqual } from 'lodash';
import { PER_PAGE_FOR_LIST } from 'constants';

const SettingRequestsByStateAndTheme = ({ state, settingName, kind }) => {
  const { t } = useTranslation('settingRequest');
  const [searchParams, setSearchParams] = useSearchParams();
  const { search } = searchParams;
  const { sort, onSortChange } = koobTableUrlSort(
    searchParams,
    setSearchParams,
  );

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [perPage, setPerPage] = useState(PER_PAGE_FOR_LIST);

  const filters = {
    search,
    discarded: state === 'archived',
    state,
    kind,
    settingName,
    page: page,
    pageSizes: perPage,
    ...formatOrderCriteria(searchParams),
  };

  const { data: settingRequests, isLoading } = useAsync({
    promiseFn: getSettingRequests,
    filters,
    watchFn: (props, prevProps) => {
      return !isEqual(props.filters, prevProps.filters);
    },
    onResolve: (response) => {
      setTotalPages(response?.headers?.xTotalPages);
    },
  });
  const totalCount = Number(settingRequests?.headers?.xTotalCount || 0);

  const columns = [
    {
      key: 'displayName',
      label: t('name'),
      sortable: true,
    },
    {
      key: 'settingName',
      label: t('settingName'),
      sortable: true,
    },
  ];

  const actions = (node) => (
    <KoobTableAction
      icon={<i className="fa-light fa-chevron-right" />}
      label={t('misc:view')}
      to={`${node?.id}/details`}
    />
  );

  // The search input lives in the KoobListPageLayout toolbar of the parent
  // settings page (it drives the same `search` query param), so this list must
  // not render one of its own.
  return (
    <div className="w-full flex flex-col gap-2">
      <KoobDataTable
        columns={columns}
        data={settingRequests?.data ?? []}
        actions={actions}
        loading={isLoading}
        sort={sort}
        onSortChange={onSortChange}
        pagination={{
          page,
          setPage,
          totalPages,
          totalCount,
          perPage,
          setPerPage,
        }}
      />
    </div>
  );
};

export default SettingRequestsByStateAndTheme;
